import { useCallback } from 'react';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
const EMPTY_PAGE = {
    clients: [],
    totalCount: 0
};
export function useClientSummaries(params) {
    let { refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { data, isLoading, error, refresh, optimisticUpdate } = useQueryState({
        queryKey: [
            QueryKeys.ClientSummaries,
            params
        ],
        queryFn: ()=>api.client.getSummaries(params),
        refreshOnHookMount
    });
    const refreshWithoutThrowing = useCallback(()=>refresh({
            throwOnError: false
        }), [
        refresh
    ]);
    return {
        page: data !== null && data !== void 0 ? data : EMPTY_PAGE,
        hasData: data != null,
        isLoading,
        error,
        refresh: refreshWithoutThrowing,
        optimisticUpdate
    };
}
